import {
  searchImpressions,
  syncSearchImpressionContext,
} from '../../helpers/src/search-impressions';
import { PANDA_SEARCH_RESULT_TYPE } from '../panda.constants';

export interface SearchAnswerImpression {
  /** The card's impression_id in the current search context; undefined without a context. */
  impressionId: string | undefined;
  reported: boolean;
  markReported: () => void;
}

// There is one Panda answer card per results page, so its identity is the context alone — not
// the run showing in it: a same-term resubmit starts a new run but is not a new impression.
const PANDA_SEARCH_ANSWER_ITEM_ID = 'panda-search-answer';

/**
 * Resolve during render, from the component that outlives the card: the card unmounts
 * mid-context (hidden toggle, resubmit) and has to come back to the same id and state.
 */
export function resolveSearchAnswerImpression(contextId?: string): SearchAnswerImpression {
  syncSearchImpressionContext(contextId);

  const impressionId = searchImpressions.getImpressionId(
    PANDA_SEARCH_ANSWER_ITEM_ID,
    PANDA_SEARCH_RESULT_TYPE,
    contextId,
  );

  return {
    impressionId,
    reported: searchImpressions.wasReported(impressionId),
    markReported: () => searchImpressions.markReported(impressionId),
  };
}
